<template>
	<el-row>
		<el-col class="v3-tabs"> <TopNav /> </el-col>
		<el-col :span="3" :offset="20" class="header-wrap text-r" style="display: flex;">
<!--			<el-dropdown>-->
<!--				<el-button class="no-b">-->
<!--					<span v-if="notificationMessagesData.totalNumber+notificationTaskData.totalNumber >0">-->
<!--						<el-badge :value="notificationMessagesData.totalNumber+notificationTaskData.totalNumber" class="item" type="primary"  >-->
<!--						<i style="color: #6989fb;border: 1px solid #6989fb;border-radius: 50%;padding: 2px;background-color: #d2dcfe;" class="el-icon-bell" aria-hidden="true"></i>-->
<!--					</el-badge>-->
<!--					</span>-->
<!--					<span  v-else >-->
<!--						<i class="el-icon-bell MyMsyStyle" aria-hidden="true"></i>-->
<!--					</span>-->
<!--				</el-button>-->

<!--				<el-dropdown-menu slot="dropdown">-->
<!--					<div class="message-container">-->
<!--						<el-tabs v-model="activeTab" @tab-click="handleTabClick"  style="    display: flex;justify-content: center;width: 100%;border-bottom: 2px solid #e4e7ed;">-->
<!--							<el-tab-pane name="todo">-->
<!--								<span slot="label" style=""> 待办 ({{notificationTaskData.totalNumber}})</span>-->
<!--							</el-tab-pane>-->
<!--							<el-tab-pane name="notification">-->
<!--								<span slot="label" style=""> 通知 ({{notificationMessagesData.totalNumber}})</span>-->
<!--							</el-tab-pane>-->

<!--						</el-tabs>-->
<!--						<div>-->
<!--							<div class="view-all" v-if="activeTab == 'notification'">-->
<!--								<div>-->
<!--									<div v-if="notificationMessagesData.list.length>0">-->
<!--										<div v-for="(message, index) in notificationMessagesData.list"  :key="index" class="message-item">-->
<!--											<div class="bgStyle" v-if="message.type ==1" style="" >-->
<!--												<div v-if="message.auditStatus ==3" @click="toPath(message.id)">-->
<!--													<div class="message-title">付款异常-客服主管-拒绝</div>-->
<!--													<div class="message-date">-->
<!--														<span style="font-weight: 500;font-size: 14px;color: #0e0e0e;">{{showPayReviewType(message.exceptionType)}}</span><span>{{message.createTime}}</span>-->
<!--													</div>-->
<!--												</div>-->
<!--											</div>-->
<!--										</div>-->
<!--									</div>-->
<!--									<div v-else class="no-data">-->
<!--										暂无消息-->
<!--									</div>-->
<!--								</div>-->
<!--								<span v-if="notificationMessagesData.totalNumber>3" class="more-messages" @click="showAllInfo">查看所有消息</span>-->
<!--							</div>-->
<!--							<div class="view-all" v-if="activeTab == 'todo'">-->
<!--								<div >-->
<!--									<div v-if="notificationTaskData.list.length>0">-->
<!--										<div v-for="(message, index) in notificationTaskData.list"  :key="index" class="message-item">-->
<!--											<div class="bgStyle" v-if="message.type ==0" style="">-->
<!--												<div class="message-title">{{ message.name }}合同到期提醒</div>-->
<!--												<div class="message-date">-->
<!--													在{{ message.contractEndDate}} 签的合同到期-->
<!--												</div>-->
<!--											</div>-->
<!--										</div>-->
<!--									</div>-->
<!--									<div v-else class="no-data">-->
<!--										暂无消息-->
<!--									</div>-->
<!--								</div>-->
<!--								<span v-if="notificationTaskData.totalNumber>3" class="more-messages" @click="showAllTaskInfo(0)">查看所有消息</span>-->
<!--							</div>-->
<!--						</div>-->

<!--					</div>-->
<!--				</el-dropdown-menu>-->
<!--			</el-dropdown>-->
			<el-dropdown>
				<el-button class="no-b" style="    height: 100%;" >
				<i class="fa fa-user-circle" aria-hidden="true"></i> <i class="el-icon-arrow-down el-icon--right"></i>
				</el-button>
				<el-dropdown-menu slot="dropdown">
				<el-dropdown-item>
					<div @click="userInfo"><i class="fa fa-address-card-o"></i>日志管理</div>
				</el-dropdown-item>
				<el-dropdown-item>
					<div @click="editPassword"><i class="fa fa-wrench"></i>修改密码</div>
				</el-dropdown-item>
				<el-dropdown-item>
					<div @click="loginOff"><i class="fa fa-power-off"></i>退出</div>
				</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-col>
	</el-row>
</template>

<script>
	import TopNav from './top-nav'
	import MessageList from './MessageList'
	import {axios} from "../config/axios";

	export default {
		components: {
			MessageList,TopNav
		},
        data() {
            return {
				name:'',
				activeTab: 'todo',
				todoMessages: [
					{ title: '消息标题消息标...', content: '消息内容消息内容消息内容消息内容...', date: '2024-01-12', isNew: true },
					{ title: '消息标题消息标...', content: '消息内容消息内容消息内容消息内容...', date: '2024-01-12', isNew: true },
					{ title: '消息标题消息标...', content: '消息内容消息内容消息内容消息内容...', date: '2024-01-12', isNew: true },
				],
				notificationMessagesData: {
					totalNumber:0,
					list:[],
				},
				notificationTaskData: {
					totalNumber:0,
					list:[],
				},
				timer: null // 用于存储定时器的引用

            };
        },
		created: function () {
			let user = JSON.parse(localStorage.getItem("logistics-userInfo"));
			// 角色有待办的 进行查询
			this.name = user.userName ;
		},

		beforeDestroy() {
			// 组件销毁前清除定时器，防止内存泄漏
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
		},
        methods: {
        	homePage(){
				this.$router.push({
					name: 'home-page',  // 跳转首页
				})
			},
			handleTabClick(tab, event) {
				this.activeTab = tab.name;
			},
			showAllInfo(){
				let defPath = '/Home/main/company-stat/notifications-stat';
				this.$router.push(defPath)
			},
			showAllTaskInfo(val){
				let defPath = '/Home/main/company-stat/notifications-stat?taskId='+val;
				if (this.$router.currentRoute.path !== defPath) {
					this.$router.push(defPath).catch(err => {
						if (err.name !== 'NavigationDuplicated') {
							// 处理除 'NavigationDuplicated' 外的其他错误
							throw err;
						}
						// 可以选择忽略或处理重复导航的错误
					});
				}

			},

            loginOff(){
				axios.post('user/loginOff',{}).then(response => {
					const code = response.code;
				}).catch(err => {
							console.log(err);
							this.alertMsg();
						});
                this.$router.push('/');
            },
            editPassword(){
                this.$router.push({
                    name: 'edit-password',  // 路由的名称
                })
            },
            userInfo(){
                this.$router.push({
                    name: 'user-info',  // 路由的名称
                })
            },

			openNavMenu(val,tabName){
				this.$store.dispatch('setTabPaneName', tabName +"_"+this.generateRandomString(6));
				this.$store.dispatch('setNavMenuOpenIndex', val+"_"+this.generateRandomString(6));
			},
			openNavMenuOpenPage(val,tabName,obj){ // 弹框打开相应的页面
				this.$store.dispatch('setTabPaneName', tabName +"_"+this.generateRandomString(6));
				this.$store.dispatch('setNavMenuOpenIndex', val+"_"+this.generateRandomString(6));
				// 传递对象到相应的页面进行展示
				this.$store.dispatch('SetTodoObject', {
					orderPaymentReviewId:obj.objectId,
					type:obj.type
				});
				// 传递对
			},
			toPath(userAnnouncementsId){
				let defPath = '/Home/main/company-stat/notifications-stat?id='+userAnnouncementsId;
				if (this.$router.currentRoute.path !== defPath) {
					this.$router.push(defPath).catch(err => {
						if (err.name !== 'NavigationDuplicated') {
							// 处理除 'NavigationDuplicated' 外的其他错误
							throw err;
						}
						// 可以选择忽略或处理重复导航的错误
					});
				}
			},
        },
    }
</script>


<style lang="less">
  .no-b{
    border: none!important
  }
  .text-r {
    text-align: right
  }

  .el-header, .el-footer {
    // background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .message-container {
	  width: 280px;
	  border-radius: 4px;
  }
  .view-all {
	  text-align: center;
	  padding: 10px;
  }
  .view-all a {
	  color: #409EFF;
	  text-decoration: none;
  }
  /* 最后一行更多消息的样式 */
  .more-messages {
	  text-align: center;
	  padding: 10px;
	  font-size: 12px;
	  font-weight: bold; /* 加粗字体 */
	  color: #409eff; /* 主题色 */
	  cursor: pointer; /* 鼠标悬停手型 */
	  transition: color 0.3s, font-size 0.3s; /* 平滑过渡效果 */
  }

  .more-messages:hover {
	  font-size: 13px; /* 稍微放大字体 */
  }

	.MyMsyStyle{
		color: rgb(171 180 199); border: 1px solid rgb(141 154 180);border-radius: 50%;padding: 2px;
	}
	.MyMsyStyle:hover{
		color: #6989fb;border: 1px solid #6989fb;border-radius: 50%;padding: 2px;background-color: #d2dcfe;
	}
  .message-list {
	  max-height: 300px;
	  overflow-y: auto;
  }
  .message-item {
	  padding: 10px;
	  border-bottom: 1px solid #e6e6e6;

  }
  .bgStyle:hover {
	  background-color: #e7eaf1;
	  cursor: pointer;
  }
  .message-title {
	  font-size: 14px;
	  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
	  font-weight: 400;
	  color: #191A1B;
	  line-height: 20px;
	  text-align: left;
	  font-style: normal;
	  margin-bottom: 5px;
  }
  .message-content {
	  color: #666;
	  margin-bottom: 5px;
	  font-size: 12px;
  }
  .message-date {
	  font-size: 12px;
	  color: #999;
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
  }
  .new-indicator {
	  width: 8px;
	  height: 8px;
	  background-color: red;
	  border-radius: 50%;
	  display: inline-block;
  }
</style>
